(() => {
  if (window.PLInteractions) return;
  const config = document.querySelector('script[data-pl-interactions]')?.dataset || {};
  const source = {
    source_product_id: config.productId || '',
    source_product_handle: config.productHandle || '',
    source_product_name: config.productName || '',
    currency: config.currency || 'USD',
    page_type: config.pageType || (config.productHandle ? 'product' : 'page'),
    tracking_version: '2',
    tracking_environment: new URLSearchParams(location.search).has('preview_theme_id') || ['unpublished', 'development'].includes(window.Shopify?.theme?.role) ? 'preview' : 'live'
  };
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== false; }
    catch (_) { return false; }
  };
  const emit = (name, data = {}) => {
    try {
      if (!allowed() || typeof window.Shopify?.analytics?.publish !== 'function') return false;
      const payload = { ...source, ...data };
      if (new URLSearchParams(location.search).get('pl_tracking_debug') === '1') {
        console.info('PL Interaction', name, JSON.stringify(payload));
      }
      const result = window.Shopify.analytics.publish(`pl:${name}`, payload);
      if (result?.catch) result.catch(() => {});
      return true;
    } catch (_) { return false; }
  };
  const locationOf = (node) => {
    if (node?.closest('cart-complementary-products, .cart-recommendations__guide')) return 'cart_recommendation';
    if (node?.closest('.ux-complete')) return 'upsell_panel';
    if (node?.closest('.sitcky-addtocart')) return 'sticky_pdp';
    if (node?.closest('cart-drawer')) return 'cart_drawer';
    if (node?.closest('predictive-search')) return 'predictive_search';
    if (node?.closest('footer, .footer')) return 'footer';
    if (node?.closest('header, header-drawer, .header-wrapper')) return 'header';
    if (node?.closest('.card-wrapper, quick-add-modal')) return 'product_card';
    if (source.page_type === 'cart') return 'cart_page';
    return source.source_product_handle ? 'main_pdp' : source.page_type;
  };
  const product = (node) => {
    const component = node?.closest('product-info-complete, product-info, product-component');
    const card = node?.closest('.ux-complete-card, .card-wrapper, .ux-start-with__colum');
    const picker = node?.closest('variant-selects') || component?.querySelector('variant-selects');
    const form = node?.closest('product-form') || component?.querySelector('product-form');
    const link = card?.querySelector('a[href*="/products/"]');
    return {
      product_id: picker?.dataset.productId || component?.dataset.productId || source.source_product_id,
      product_handle: picker?.dataset.productHandle || (form?.dataset.cartUrl || link?.getAttribute('href'))?.split('/products/')[1]?.split(/[?#]/)[0] || source.source_product_handle,
      product_name: picker?.dataset.productTitle || form?.dataset.cartTitle || link?.textContent.trim() || source.source_product_name
    };
  };
  document.addEventListener('click', (event) => {
    const target = event.target.closest ? event.target : event.target.parentElement;
    const checkout = target?.closest('#CartDrawer-Checkout, #checkout');
    if (checkout && !checkout.disabled && checkout.name === 'checkout') {
      emit('checkout_button_click', {
        interaction_location: checkout.id === 'CartDrawer-Checkout' ? 'cart_drawer' : 'cart_page',
        button_text: checkout.textContent.trim().replace(/\s+/g, ' ')
      });
    }
    const opener = target?.closest('.product-ux-complete');
    if (opener) {
      const panel = document.querySelector('.ux-complete');
      const alreadyOpen = panel?.classList.contains('active');
      setTimeout(() => {
        if (!alreadyOpen && panel?.classList.contains('active')) {
          emit('upsell_panel_open', { interaction_location: 'main_pdp', panel_name: 'complete_the_product', button_text: opener.textContent.trim() });
        }
      });
    }
    const options = target?.closest('.ux-complete-card-show');
    if (options) {
      const card = options.closest('.ux-complete-card');
      const alreadyOpen = card?.classList.contains('active');
      setTimeout(() => {
        if (!alreadyOpen && card?.classList.contains('active')) {
          emit('upsell_product_select', { ...product(options), interaction_location: locationOf(options), selection_type: 'open_options' });
        }
      });
    }
    const link = target?.closest('.ux-complete a[href*="/products/"], cart-complementary-products a[href*="/products/"]');
    if (link && (link.closest('cart-complementary-products') || link.closest('.ux-complete')?.classList.contains('active'))) {
      if (!link.closest('cart-complementary-products')?.suppressDragClick) {
        emit('upsell_product_select', { ...product(link), interaction_location: locationOf(link), selection_type: 'product_link' });
      }
    }
    const size = target?.closest('.size_action');
    if (size && !size.closest('cart-complementary-products')) {
      const guide = document.querySelector(`.ux-size-guide[data-product-id="${CSS.escape(size.dataset.productId || '')}"]`);
      const alreadyOpen = guide?.classList.contains('active');
      setTimeout(() => {
        if (!alreadyOpen && guide?.classList.contains('active')) {
          emit('size_guide_open', { ...product(size), product_id: size.dataset.productId || product(size).product_id, interaction_location: locationOf(size) });
        }
      });
    }
  }, true);
  window.PLInteractions = {
    emit, allowed, product, locationOf,
    added(form, response, quantity, context = {}) {
      try {
        if (response.status || !form.matches('product-form')) return;
        const info = product(form);
        const lines = response.items || [response];
        const items = lines.map(line => ({
          item_id: String(line.product_id || info.product_id),
          item_name: line.product_title || info.product_name,
          item_variant: line.variant_title || '',
          price: Number(line.final_price ?? line.price ?? 0) / 100,
          quantity: response.items ? line.quantity : quantity,
        }));
        const payload = {
          ...info,
          ...context,
          interaction_location: locationOf(form),
          variant_id: String(lines[0]?.variant_id || lines[0]?.id || ''),
          quantity: items.reduce((sum, item) => sum + item.quantity, 0),
          value: items.reduce((sum, item) => sum + item.price * item.quantity, 0),
          items,
        };
        emit('cart_add_success', payload);
        if (['upsell_panel', 'cart_recommendation'].includes(payload.interaction_location)) emit('upsell_add_to_cart', payload);
      } catch (_) {}
    },
    shoppingError(node, code, action) {
      const category = ['INVALID', 'SERVICE_UNAVAILABLE', 'CART_REFRESH_FAILED'].includes(code) ? code.toLowerCase() : 'unknown';
      emit('shopping_error', { ...product(node), interaction_location: locationOf(node), action, error_category: category });
    },
    cartDrawerView(cartDataPromise) {
      if (!allowed()) return;
      const cartRequest = cartDataPromise || (typeof CartItems !== 'undefined'
        ? CartItems.fetchCartData()
        : fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin' })
          .then(response => { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); }));
      cartRequest.then(cart => emit('cart_drawer_view', {
          interaction_location: 'cart_drawer',
          currency: cart.currency || source.currency,
          value: cart.total_price / 100,
          cart_quantity: cart.item_count,
          items: cart.items.map(item => ({ item_id: String(item.product_id), item_name: item.product_title, item_variant: item.variant_title || '', price: item.final_price / 100, quantity: item.quantity }))
        }))
        .catch(() => {});
    }
  };
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    let wasOpen = drawer.classList.contains('active');
    let pendingView = false;
    new MutationObserver(() => {
      const isOpen = drawer.classList.contains('active');
      if (isOpen && !wasOpen) {
        if (drawer.isAdding) pendingView = true;
        else window.PLInteractions.cartDrawerView();
      }
      if (pendingView && !drawer.isAdding) {
        pendingView = false;
        if (isOpen) window.PLInteractions.cartDrawerView(drawer.confirmedCartDataPromise);
      }
      if (!isOpen) pendingView = false;
      wasOpen = isOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
})();
